export const BORDER_GRADIENT = {
  LEFT: 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #A0C7F4 49.14%)',
  RIGHT: 'linear-gradient(90deg, #A0C7F4 49.14%, rgba(255, 255, 255, 0) 100%)'
};

export const getProfileModeSelectVerifications = (verificationsString: string) =>
  ({
    ...(verificationsString?.includes('aadhaar') ? { AADHAAR: 'aadhaar' } : {}),
    ...(verificationsString?.includes('passport') ? { PASSPORT: 'passport' } : {}),
    ...(verificationsString?.includes('dl') ? { DRIVING_LICENSE: 'dl' } : {})
  }) as const;

export type ProfileModeSelectVerificationsType = ReturnType<
  typeof getProfileModeSelectVerifications
>;
export type ProfileModeSelectVerificationKey = keyof ProfileModeSelectVerificationsType;
